import React from 'react';

/**
 * Separador decorativo: línea delgada con degradado arcoíris pastel
 * (rosa → lila → durazno) y una estrellita ✦ centrada.
 * Solo decorativo, no modifica el flujo. Móvil-first.
 */
export default function SectionDivider({ className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={`relative max-w-3xl mx-auto my-8 sm:my-12 px-4 ${className}`}
    >
      <div className="h-px sm:h-0.5 w-full bg-gradient-to-r from-transparent via-pinky-300 to-transparent" />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 px-2 bg-white"
        style={{
          backgroundImage: 'linear-gradient(90deg, transparent 0%, #FFFCFD 18%, #FFFCFD 82%, transparent 100%)',
        }}
      >
        <span className="text-pinky-400 text-sm sm:text-base select-none" style={{ lineHeight: 1 }}>
          ✦
        </span>
      </div>
    </div>
  );
}
